import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Customer-facing API calls need credentials so the session_token cookie is sent.
export const customerApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Emergent Google login — redirect to the provider.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startCustomerLogin = () => {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const logoutCustomer = async () => {
  try {
    await customerApi.post("/auth/logout");
  } catch {
    /* ignore */
  }
  window.location.href = "/";
};
